import React, {Component} from 'react'
import {withTranslation} from "react-i18next"
import Moment from "moment/moment";

import {AWARD_VIEW_BY_OPTIONS} from './common'
import CalendarRow from './CalendarRow'

import {Hr, View} from '@amzn/stencil-react-components/layout'
import Section from "../common/Section";

class CalendarSection extends Component {

  getSectionTitle(sections, calendarType, t) {
    let title = t("StockAwards.NoAwardsMessage");

    if (!sections || sections.length <= 0) {
      return title;
    }

    if (calendarType === AWARD_VIEW_BY_OPTIONS.CALENDAR_YEAR) {
      title = t('StockAwards.CalendarSection.CalendarTitle', {years: sections.length});
    }

    if (calendarType === AWARD_VIEW_BY_OPTIONS.COMPENSATION_YEAR) {
      title = t('StockAwards.CalendarSection.CompTitle', {years: sections.length});
    }

    if (calendarType === AWARD_VIEW_BY_OPTIONS.CUSTOM) {
      if (!(sections.length === 1 && sections[0].remaining.length === 0 && sections[0].completed.length === 0)) {
        title = t('StockAwards.CalendarSection.CustomTitle');
      }
    }

    return title;
  }

  getRowTitle(year, isCustom, startMonth = null, endMonth = null) {
    let beginYear;
    let endYear;

    if (startMonth) {
      beginYear = Moment(new Date(year, startMonth - 1, 1)).format('ll');
      endYear = Moment(new Date(parseInt(year) + 1, endMonth - 1, 31)).format('ll');
    } else {
      beginYear = Moment(new Date(year, 0, 1)).format('ll');
      endYear = Moment(new Date(year, 11, 31)).format('ll');
    }

    return !isCustom ? `${beginYear} - ${endYear}` : "";
  }

  getRowSubTitle(isCustom, section, t) {
    if (isCustom) {
      return "";
    }

    return t('StockAwards.CalendarSection.SubTitle', {
      rsus: section.rsus,
      awards: section.awards.length
    });
  }

  render() {
    const {sections, startMonth, endMonth, t} = this.props;
    const isCustom = this.props.isCustom ? true : false;
    const sectionTitle = this.getSectionTitle(sections, this.props.calendarType, t);
    
    return (
      <Section title={sectionTitle} shouldExpandOnMount={true}>
        {sections && sections.map((section, index) => {
          return (
            <>
              <View margine={{bottom: 5}}>
                <CalendarRow
                  title={this.getRowTitle(section.year, isCustom, startMonth, endMonth)}
                  subTitle={this.getRowSubTitle(isCustom, section, t)}
                  selectedAwardIds={section.awards}
                  completedVests={section.completed}
                  remainingVests={section.remaining}
                  broker={this.props.broker}
                  isCustom={isCustom}
                  year={section.year}
                  onRowMenuItemClick={this.props.onCalendarMenuItemClick}
                  onChangePaymentMethodClick={this.props.onChangePaymentMethodClick}
                />
              </View>
              <View margin={10}>
                <Hr/>
              </View>
            </>
          )
        })}
      </Section>
    )
  }
}

export default withTranslation('translationsV2')(CalendarSection)
